/*
         * @ngdoc function
         * @name ePay.WebApi:StatesWebApi
         * @description
         * Web Api Service
         */
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams} from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { StatesModel } from '../../Models/Model/StatesModel';

@Injectable()
export class StatesWebApi {
	constructor(private http: HttpClient) { }


	by_Abbreviation(abbreviation?: string) {
		let _formdata = new FormData();
		let headers = new HttpHeaders();
		headers.append('Content-Type', 'application/json');
		let urlParams = new HttpParams();
		if (abbreviation !== null && typeof abbreviation !== 'undefined')
		{
			urlParams = urlParams.append('abbreviation', abbreviation.toString());
		}
		return this.http.post<StatesModel[]>('/api/States/By_Abbreviation', _formdata, {headers: headers, params: urlParams})
	}


	by_State(state?: string) {
		let _formdata = new FormData();
		let headers = new HttpHeaders();
		headers.append('Content-Type', 'application/json');
		let urlParams = new HttpParams();
		if (state !== null && typeof state !== 'undefined')
		{
			urlParams = urlParams.append('state', state.toString());
		}
		return this.http.post<StatesModel[]>('/api/States/By_State', _formdata, {headers: headers, params: urlParams})
	}


	list(abbreviation?: string) {
		let _formdata = new FormData();
		let headers = new HttpHeaders();
		headers.append('Content-Type', 'application/json');
		let urlParams = new HttpParams();
		if (abbreviation !== null && typeof abbreviation !== 'undefined')
		{
			urlParams = urlParams.append('abbreviation', abbreviation.toString());
		}
		return this.http.post<StatesModel[]>('/api/States/List', _formdata, {headers: headers, params: urlParams})
	}


	save(statesModel: StatesModel) {
		let headers = new HttpHeaders();
		let urlParams = new HttpParams();
		headers.append('Content-Type', 'application/json');
		return this.http.post<StatesModel>('/api/States/Save', statesModel, {headers: headers, params: urlParams})
	}

}
